<template>
  <v-container>
    <v-btn color="primary" text class="text-h5 mt-10" @click="goBack()">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("common.back") }}
    </v-btn>
    <v-row class="text-h2 justify-center pa-10">
      {{ $t(`family.${update ? "update" : add ? "add" : "show"}.title`) }}
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="validate"
      :readonly="show"
    >
      <v-row class="justify-center">
        <v-col cols="12" sm="6" class="justify-end">
          <v-text-field
            v-if="family"
            v-model="family.name"
            :rules="[(v) => !!v || $t('family.form.error.name')]"
            :label="$t('family.form.label.name')"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <DataListMoleculeComponent v-if="!this.add"></DataListMoleculeComponent>
    <v-row class="justify-center">
      <v-btn
        v-if="!show"
        :disabled="!valid"
        color="success"
        class="ma-4"
        @click="validate"
      >
        {{ $t(`family.button.${update ? "update" : "add"}`) }}
      </v-btn>
      <v-btn
        v-if="this.update"
        :disabled="!valid"
        color="error"
        class="ma-4"
        @click="deleteItem"
      >
        {{ $t(`family.button.delete`) }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import { useFamilyStore } from "@/store/familyStore";
import Vue, { ref } from "vue";
import { storeToRefs } from "pinia";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";
import { useUserStore } from "@/store/userStore";
import DataListMoleculeComponent from "@/components/molecule/DataListMoleculeComponent.vue";
import { useMoleculeStore } from "@/store/moleculeStore";

export default {
  components: { DataListMoleculeComponent },
  data: () => ({
    valid: true,
    store: useFamilyStore(),
    userStore: useUserStore(),
    moleculeStore: useMoleculeStore(),
    family: ref(null),
  }),
  props: {
    add: Boolean,
    update: Boolean,
    show: Boolean,
  },
  async beforeMount() {
    if ((this.update || this.add) && !this.userStore.isWriter()) {
      Vue.$toast(i18n.t("family.toast.access.error"), {
        timeout: 2000,
        position: POSITION.TOP_CENTER,
        type: TYPE.ERROR,
      });
      this.goBack();
      return;
    }
    this.family = storeToRefs(this.store).family;
    if (!this.add) {
      await this.store.getFamilyById(parseInt(router.currentRoute.params.id));
      this.moleculeStore.molecules = this.family.molecules;
    }
  },
  methods: {
    validate() {
      if (!this.show && this.$refs.form.validate()) {
        if (this.update) {
          this.store.updateFamily().then(() => this.goBack());
        } else {
          this.store.addFamily().then(() => this.goBack());
        }
      }
    },
    goBack() {
      this.store.$reset();
      this.moleculeStore.$reset();
      router.go(-1);
    },
    deleteItem() {
      if (confirm(this.$t("family.delete.confirm"))) {
        this.store.deleteFamily(this.family.id);
        this.goBack();
      }
    },
  },
};
</script>
